---
description: Box and case lids that close first try — lip clearance, taper, corner relief and warp control. Load for boxes, cases and enclosures with a mating lid.
---

Needs fit-clearance and printability-design numbers.

Clearance per side: 0.15-0.35, default 0.25 with ~6 mm deep lip. Below 0.15 binds at corners; above 0.35 rattles. Long lips forgive less: a 20 mm lip needs a bigger gap than a 5 mm one, since warp accumulates along the length.

Lip geometry: depth 5-6 default; shallow rocks, deep binds. Taper the entry at 1-2 plus a 0.3-0.5 x 45 mouth chamfer on both parts so the lid self-centers. Corner relief: lids bind at corners first — add 0.3-0.5 extra corner radius on the inner part or small corner notches, never sharp inside corners. For warp-prone large lids, thin the skirt wall (0.8-1.0) so it flexes over the box instead of demanding a perfect gap.

Warp and foot: bottom-corner fillets >= 1 mm, bottom-edge 0.5-1.0 x 45 chamfer against elephant foot (the classic rocking lid). Rib under large flat tops. Slicer hint only: elephant-foot comp 0.1-0.2.

Globals: LidGap per side (default 0.25), LipDepth (6), LeadChamfer (0.4). One slider per value; never scale-to-fix.

Coupon: print a 20-30 mm corner section of the lip pair, not the whole box. Firm push to seat with no rattle ships it. Verify with measure/check.

Sources: loftsmith tolerances, slant-3d tolerance videos, emrldlabs enclosures.
